export default __webpack_public_path__ + "static/media/upsidepizza.940f6781.jpeg";